module.exports = __webpack_public_path__ + "img/stablecoins-texture.f5d9599b.jpg";